import React, { useCallback, useEffect, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { IoArrowBack, IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';

import FormRemoveVehicle from '@components/FormRemoveVehicle';
import {
  SubtitleSecondary,
  ButtonDefault,
  MenuSideBarPrivate,
  HeaderNavigationPrivate,
  InputText,
} from '@components/index';
import Car from '@models/Car';
import { apiRebox } from '@services/index';
import { toastify } from '@utils/notifiers';

import {
  Container,
  ContainerGroup,
  Content,
  FormPage,
  Options,
  OptionsGroup,
  Pagination,
  PaginationGroup,
  PaginationGroupText,
} from './styles';

const RemoveVehicle: React.FC = () => {
  const { goBack } = useHistory();
  const formPageRef = useRef<FormHandles>(null);

  const [cars, setCars] = useState<Car[]>([]);
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleGetCars = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data: response } = await apiRebox.get('/cars');
      const { header, data } = response;
      setTotalPages(Math.round(header.total / header.per_page));
      setTotal(header.total);
      setCars(data);
    } catch (error) {
      toastify('Houve um erro ao buscar os modelos veiculares', 'error');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handlePage = useCallback(async (requestPage: number) => {
    try {
      const { data: response } = await apiRebox.get('/cars', {
        params: {
          page: requestPage,
        },
      });
      setCars(response.data);
    } catch (error) {
      toastify('Houve um erro ao buscar os modelos veiculares', 'error');
    }
  }, []);

  const handleGoBack = () => {
    goBack();
  };

  useEffect(() => {
    handleGetCars();
  }, []);

  useEffect(() => {
    handlePage(page);
  }, [page]);

  return (
    <Container>
      <HeaderNavigationPrivate />
      <ContainerGroup>
        <MenuSideBarPrivate />
        <Content>
          <SubtitleSecondary textAlign="start">
            Remova um modelo veicular
          </SubtitleSecondary>
          <Options>
            <OptionsGroup>
              <ButtonDefault iconLeft={IoArrowBack} onClick={handleGoBack} />
            </OptionsGroup>
          </Options>
          <Pagination>
            <ButtonDefault
              style={{
                borderRadius: '8px 0 0 8px',
                maxWidth: 100,
              }}
              disabled={page === 1}
              isDisable={page === 1}
              onClick={() => setPage(1)}
            >
              Primeira
            </ButtonDefault>
            <ButtonDefault
              iconLeft={IoChevronBack}
              style={{
                borderRadius: '0',
                maxWidth: 30,
                padding: '0 5px',
                margin: '0 5px',
              }}
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            />
            <PaginationGroup>
              <FormPage
                ref={formPageRef}
                onSubmit={() => console.log('')}
                initialData={{ currentPage: page }}
              >
                <InputText
                  name="currentPage"
                  type="number"
                  min="1"
                  value={page}
                  onChange={event => {
                    if (!(event.target.value === '')) {
                      setPage(Number.parseInt(event.target.value, 10));
                    }
                  }}
                />
              </FormPage>
              <PaginationGroupText>de {totalPages}</PaginationGroupText>
              <ButtonDefault
                iconLeft={IoChevronForward}
                style={{
                  borderRadius: '0',
                  maxWidth: 30,
                  padding: '0 5px',
                  margin: '0 5px',
                }}
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              />
              <ButtonDefault
                style={{
                  borderRadius: '0 8px 8px 0',
                  maxWidth: 100,
                }}
                disabled={page === totalPages}
                isDisable={page === totalPages}
                onClick={() => setPage(totalPages)}
              >
                Última
              </ButtonDefault>
            </PaginationGroup>
          </Pagination>
          <FormRemoveVehicle cars={cars} total={total} isLoading={isLoading} />
          <Pagination>
            <ButtonDefault
              style={{
                borderRadius: '8px 0 0 8px',
                maxWidth: 100,
              }}
              disabled={page === 1}
              isDisable={page === 1}
              onClick={() => setPage(1)}
            >
              Primeira
            </ButtonDefault>
            <ButtonDefault
              iconLeft={IoChevronBack}
              style={{
                borderRadius: '0',
                maxWidth: 30,
                padding: '0 5px',
                margin: '0 5px',
              }}
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            />
            <PaginationGroup>
              <FormPage
                ref={formPageRef}
                onSubmit={() => console.log('')}
                initialData={{ currentPage: page }}
              >
                <InputText
                  name="currentPage"
                  type="number"
                  min="1"
                  value={page}
                  onChange={event => {
                    if (!(event.target.value === '')) {
                      setPage(Number.parseInt(event.target.value, 10));
                    }
                  }}
                />
              </FormPage>
              <PaginationGroupText>de {totalPages}</PaginationGroupText>
              <ButtonDefault
                iconLeft={IoChevronForward}
                style={{
                  borderRadius: '0',
                  maxWidth: 30,
                  padding: '0 5px',
                  margin: '0 5px',
                }}
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              />
              <ButtonDefault
                style={{
                  borderRadius: '0 8px 8px 0',
                  maxWidth: 100,
                }}
                disabled={page === totalPages}
                isDisable={page === totalPages}
                onClick={() => setPage(totalPages)}
              >
                Última
              </ButtonDefault>
            </PaginationGroup>
          </Pagination>
        </Content>
      </ContainerGroup>
    </Container>
  );
};

export default RemoveVehicle;
